import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { YourDependantDetails } from '../../model/ngrx/your-dependant-details.model';

export const ADD_YOUR_DEPENDANT_DETAILS = '[YOURDEPENDANTDETAIL] Add';
export const REMOVE_YOUR_DEPENDANT_DETAILS = '[YOURDEPENDANTDETAIL] Remove';

// AddDependantDetails in Apply Journey
export class AddYourDependantDetails implements Action {
    readonly type = ADD_YOUR_DEPENDANT_DETAILS;

    constructor(public payload: YourDependantDetails) { }
}
// RemoveDependantDetails in Apply Journey
export class RemoveYourDependantDetails implements Action {
    readonly type = REMOVE_YOUR_DEPENDANT_DETAILS;

    constructor(public payload: number) { }
}

export type Actions = AddYourDependantDetails | RemoveYourDependantDetails;
